export const kUntitledDraftName = 'Untitled draft'

/**
 * How often the Drafts list refetches while the page is open and visible.
 *
 * Only the tab that makes a change marks the drafts stale, so a page left open never hears about
 * another member's work and has to ask.
 */
export const kDraftsPollIntervalMs = 30 * 1000
